var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnonymity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.635 21.7505L49.6357 21.7419C50.0321 17.5233 46.6879 13.7916 42.3747 13.7916C40.1924 13.7916 38.5701 15.6758 38.7591 17.7436L40.071 32.1334H48.6966C48.903 29.8716 49.2821 25.7021 49.635 21.7505Z",
    fill: "url(#paint0_linear_1825_191759)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1136 20.1285C26.5866 20.5105 29.2501 23.2851 29.6254 26.6404L36.4239 33.4389L35.0252 18.0863C34.6361 13.8261 37.9879 10.0417 42.3752 10.0417C48.8829 10.0417 53.9706 15.6613 53.3703 22.0871L52.2836 34.0942V38.025C52.2836 41.0703 50.5506 43.7166 48.0199 45.0348L60.9094 57.9243C63.0526 55.2103 64.3334 51.7854 64.3334 48.0666V15.9334C64.3334 7.14775 57.1857 0 48.4001 0H16.2668C12.5481 0 9.12318 1.28087 6.40918 3.42412L23.1136 20.1285Z",
    fill: "url(#paint1_linear_1825_191759)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.533 38.025V35.8834H40.233V37.2484L45.0969 42.1122C47.0461 41.7727 48.533 40.0699 48.533 38.025ZM43.564 45.8826C39.8606 45.4994 36.9088 42.5475 36.5255 38.8441L29.3214 31.64L28.183 44.1346V48.0667C28.183 52.4229 24.6391 55.9667 20.283 55.9667C15.9269 55.9667 12.383 52.4227 12.383 48.0667V44.1359L11.2963 32.1287C10.8209 27.04 13.913 22.4577 18.4521 20.7707L3.75713 6.07574C1.61388 8.78974 0.333008 12.2146 0.333008 15.9334V48.0666C0.333008 56.8522 7.48076 64 16.2664 64H48.3996C52.1183 64 55.5433 62.7191 58.2573 60.5759L43.564 45.8826Z",
    fill: "url(#paint2_linear_1825_191759)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8698 28.1888L21.5526 23.8715C17.6036 24.2683 14.6566 27.809 15.03 31.7835L15.0307 31.7921C15.3836 35.7438 15.7627 39.9133 15.9691 42.175H24.5947L25.8698 28.1888ZM20.2827 52.2166C22.571 52.2166 24.4327 50.3549 24.4327 48.0666V45.925H16.1327V48.0666C16.1327 50.355 17.9943 52.2166 20.2827 52.2166Z",
    fill: "url(#paint3_linear_1825_191759)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1825_191759",
    x1: 38.7441,
    y1: 22.9625,
    x2: 49.6677,
    y2: 22.9625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1825_191759",
    x1: 6.40918,
    y1: 28.9621,
    x2: 64.3334,
    y2: 28.9621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1825_191759",
    x1: 0.333008,
    y1: 35.0379,
    x2: 58.2573,
    y2: 35.0379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1825_191759",
    x1: 14.998,
    y1: 38.0441,
    x2: 25.8698,
    y2: 38.0441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434343"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnonymity);
export default __webpack_public_path__ + "static/media/anonymity.fc7acab4fb148e4cb81e080d730d5a4e.svg";
export { ForwardRef as ReactComponent };